export const FETCH_ORDER_HISTORY = "FETCH_ORDER_HISTORY";
export const FETCH_SINGLE_ORDER = "FETCH_SINGLE_ORDER";
export const SET_ORDER_ID = "SET_ORDER_ID";
